import api from '..'

const download = (id: string) => {
  return api.post<string>(`/administration/learning_paths/${id}/report`)
}

export default download
